import React, { createElement } from 'react';
import { components } from './Components';
import __isArray from 'lodash/isArray';
import styles from './cosNoticia.module.scss';

const CosNoticiaParsejat = (props) => {
    const { cos } = props;

    const result = cos.map((item, index) => {
        const tipus = item.tipus?.toUpperCase();
        const component = components[tipus];
        return component ? (
            <React.Fragment key={`cos-component-${item.tipus}-${index}`}>
                {createElement(component, {
                    ...item.props
                })}
            </React.Fragment>
        ) : null;
    });
    return (
        <div data-testid='item-noti-cos' className={styles.cos}>
            {result}
        </div>
    );
};

const Cos = (props) => {
    const { cos } = props;
    return __isArray(cos) ? <CosNoticiaParsejat cos={cos} /> : <></>;
};

export default Cos;
